import {
  SAVE_POI_GROUP_FAILURE,
  SAVE_POI_GROUP_SUCCESS,
  SAVE_POI_GROUP_REQUEST,
  FETCH_POI_GROUPS_REQUEST,
  FETCH_POI_GROUPS_SUCCESS,
  FETCH_POI_GROUPS_FAILURE,
  DELETE_POI_GROUP_REQUEST,
  DELETE_POI_GROUP_SUCCESS,
  DELETE_POI_GROUP_FAILURE,
  FETCH_POI_GROUP_REQUEST,
  FETCH_POI_GROUP_SUCCESS,
  FETCH_POI_GROUP_FAILURE,
  FETCH_POI_GROUP_COMPLETE_REQUEST,
  FETCH_POI_GROUP_COMPLETE_SUCCESS,
  FETCH_POI_GROUP_COMPLETE_FAILURE,
} from '../types';

const INITIAL_STATE = {
  poiGroups: [],
  poiGroup: null,
  poiGroupComplete: null,
  poiGroupImageUrl: '',
  loading: false,
  error: null,
  simplepPoiGroupList: null,
  simplepPoiGroupListLoading: false,
  custompPoiGroupList: null,
  custompPoiGroupListLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_POI_GROUPS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_POI_GROUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        poiGroups: action.payload,
      };

    case FETCH_POI_GROUPS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        poiGroups: [],
      };

    case SAVE_POI_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_POI_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SAVE_POI_GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case DELETE_POI_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_POI_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case DELETE_POI_GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case FETCH_POI_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_POI_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        poiGroup: action.payload,
      };

    case FETCH_POI_GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        poiGroup: null,
      };

    case FETCH_POI_GROUP_COMPLETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_POI_GROUP_COMPLETE_SUCCESS:
      return {
        ...state,
        loading: false,
        poiGroupComplete: action.payload,
      };

    case FETCH_POI_GROUP_COMPLETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        poiGroupComplete: null,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
